import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=7094b200&scoped=true"
import script from "./TaskType.vue?vue&type=script&lang=js"
export * from "./TaskType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094b200",
  null
  
)

export default component.exports